<div class="vs-card" *ngIf="openCard && vsQuote?.quoteId" [ngClass]="active === vsQuote?.quoteId ? 'active':''" (click)="setActive()">
    <div class="row">
        <div class="col-10">    
            <div>{{ "quoteTracking.hashQuote" | cxTranslate }}</div>
            <div class="quote-number">{{vsQuote?.quoteId}}</div>
        </div>
        <div class="col-2"><i class="material-icons close-icon" (click)="closeCard($event, 12345)">close</i></div>
    </div>
    <div class="space-verticle">
        <div>{{ "quoteTracking.quoteTotal" | cxTranslate }}</div>
        <div class="bold">{{vsQuote?.quoteTotal}}</div>
    </div>
    <div class="space-verticle">
        <div>{{ "quoteTracking.quoteCreated2" | cxTranslate }}</div>
        <div class="bold">{{vsQuote?.createdDate}}</div>
    </div>
    <div class="space-verticle">
        <div>{{ "quoteTracking.customerReference1" | cxTranslate }}</div>
        <div class="bold ellipsis">{{vsQuote?.quoteReference}}</div>
    </div>
</div>
<div class="vs-card align-center" *ngIf="!openCard || !vsQuote?.quoteId" (click)='navigateToList()'>
    <i class="material-icons add-quote-icon">add_circle_outline</i>
</div>
    